import React from 'react';

import {
  TopText,
  BottomText,
  RightText,
  TextContainer,
  SummaryRowContainer,
} from './SummaryRow.style';

const SummaryRow: React.FC<{
  topText?: string;
  bottomText?: string | null;
  rightText?: string;
}> = ({ topText = '', bottomText = '', rightText = '' }) => {
  return (
    <SummaryRowContainer>
      <TextContainer>
        <TopText>{topText}</TopText>
        <BottomText>{bottomText}</BottomText>
      </TextContainer>

      <RightText>{rightText}</RightText>
    </SummaryRowContainer>
  );
};

export default SummaryRow;
